import type { Translate } from "../../../i18n";

/** 만료일 — 와이어 '만료 2026-10-24'(현지 날짜 yyyy-mm-dd) */
export function shareDate(iso: string | null): string {
  const t = iso ? Date.parse(iso) : NaN;
  if (!Number.isFinite(t)) return "";
  const d = new Date(t);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** 길이 — 와이어 '2분 30초' */
export function shareLength(t: Translate, s: number): string {
  const total = Math.max(0, Math.round(s));
  const m = Math.floor(total / 60);
  const sec = total % 60;
  if (m === 0) return t("share.lenS", { s: sec });
  return sec ? t("share.lenMS", { m, s: sec }) : t("share.lenM", { m });
}
